import { CircleHelp } from "lucide-react";
import React, { ReactNode } from "react";

import { IgAnalyticsTooltip } from "@intelligems/ig-theme/IgAnalyticsTooltip";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Grid from "@mui/material/Grid";
import { CompareGroupsFilter } from "@src/features/analytics/baseDashboard/CompareGroupsFilter";

interface BaseMetricSectionHeaderProps {
  groupTitle: string;
  showCompareGroups?: boolean;
  headerDropdown?: ReactNode;
  rightSideButtons?: ReactNode[];
  tooltip?: string;
}

export const BaseMetricSectionHeader = ({
  groupTitle,
  showCompareGroups,
  headerDropdown,
  rightSideButtons,
  tooltip,
}: BaseMetricSectionHeaderProps) => {
  return (
    <Grid
      container
      sx={{
        padding: "20px 30px",
      }}
      direction={"row"}
      alignItems={"center"}
      columnSpacing={4}
      justifyContent={"space-between"}
      wrap={"nowrap"}
    >
      <Grid container direction={"row"} alignItems={"center"} columnSpacing={4}>
        <Grid>
          <IgTypography variant={"h2"} fontWeight={600}>
            {groupTitle}
          </IgTypography>
        </Grid>
        {tooltip && (
          <div style={{ height: "20px", marginTop: "2px" }}>
            <IgAnalyticsTooltip title={tooltip}>
              <CircleHelp
                size={18}
                style={{
                  marginLeft: "5px",
                }}
              />
            </IgAnalyticsTooltip>
          </div>
        )}
        {showCompareGroups && (
          <Grid>
            <CompareGroupsFilter />
          </Grid>
        )}
        {headerDropdown && <Grid>{headerDropdown}</Grid>}
      </Grid>
      {rightSideButtons && (
        <Grid
          container
          columnSpacing={2}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          {rightSideButtons.map((btn, index) => (
            <Grid key={index}>{btn}</Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};
